import { useState, useCallback } from 'react';

const API_URL = process.env.REACT_APP_API_URL || '';

export const useAdminTunnels = () => {
  const [tunnels, setTunnels] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchTunnels = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(`${API_URL}/admin/tunnels`, { credentials: 'include' });
      if (response.ok) {
        setTunnels(await response.json() || []);
      }
    } catch (err) {
      console.error('Failed to fetch tunnels:', err);
      setError('Не удалось загрузить туннели');
    } finally {
      setLoading(false);
    }
  }, []);

  const blockTunnel = useCallback(async (tunnelId, reason, duration) => {
    try {
      await fetch(`${API_URL}/admin/tunnels/${tunnelId}/block`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ reason, duration })
      });
      await fetchTunnels();
      return { success: true };
    } catch (err) {
      console.error('Failed to block tunnel:', err);
      return { success: false, error: 'Не удалось заблокировать туннель' };
    }
  }, [fetchTunnels]);

  const unblockTunnel = useCallback(async (tunnelId) => {
    try {
      await fetch(`${API_URL}/admin/tunnels/${tunnelId}/unblock`, {
        method: 'POST',
        credentials: 'include'
      });
      await fetchTunnels();
      return { success: true };
    } catch (err) {
      console.error('Failed to unblock tunnel:', err);
      return { success: false, error: 'Не удалось разблокировать туннель' };
    }
  }, [fetchTunnels]);

  const deleteTunnel = useCallback(async (tunnelId) => {
    try {
      await fetch(`${API_URL}/admin/tunnels/${tunnelId}`, {
        method: 'DELETE',
        credentials: 'include'
      });
      await fetchTunnels();
      return { success: true };
    } catch (err) {
      console.error('Failed to delete tunnel:', err);
      return { success: false, error: 'Не удалось удалить туннель' };
    }
  }, [fetchTunnels]);

  return {
    tunnels,
    loading,
    error,
    fetchTunnels,
    blockTunnel,
    unblockTunnel,
    deleteTunnel
  };
};